import React from 'react';
import { DialogTitle, Typography, IconButton, Box } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { colors, fonts, spacing } from '../../../constants';

/**
 * EditQueryModalHeader Component
 * Header for EditQueryModal with title and close button
 * 
 * @param {Function} onClose - Close handler
 */
const EditQueryModalHeader = ({ onClose }) => {
  return (
    <DialogTitle
      sx={{
        padding: `${spacing.xs} ${spacing.sm}`,
        borderBottom: 'none',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: colors.primaryGradient,
        position: 'sticky',
        top: 0,
        zIndex: 1,
        boxShadow: `0 18px 32px ${colors.primaryShadow}`,
      }}
    >
      <Typography
        variant="h5"
        component="span"
        sx={{
          fontWeight: fonts.weightBold,
          fontSize: fonts.fontSizeLg,
          color: colors.textWhite,
          letterSpacing: '-0.5px',
        }}
      >
        Edit Query
      </Typography>
      <IconButton
        onClick={onClose}
        sx={{
          color: colors.textWhite,
          padding: spacing.xs,
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: colors.primaryTint,
            color: colors.textWhite,
            transform: 'rotate(90deg)',
          },
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

export default EditQueryModalHeader;
